module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-news",
    class: {
      loading: _vm.list.loading
    }
  }, [_c('div', {
    staticClass: "news-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.keywords),
      expression: "keywords",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Søg efter nyhed her..."
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.filter.yearSelect) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Vælg år")]), _vm._v(" "), _vm._l((_vm.filter.yearSelect), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "textContent": _vm._s(option.text)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('button', [_vm._v("Søg")])])]), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, [_c('div', {
    class: ['search-message', {
      'show': _vm.showMessage
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.messageStatus)
    }
  }), _vm._v(" "), _vm._l((_vm.result), function(year, y) {
    return _c('div', {
      key: y,
      staticClass: "year"
    }, _vm._l((year.months), function(month, m) {
      return _c('div', {
        key: m,
        staticClass: "group"
      }, [_c('h2', {
        domProps: {
          "textContent": _vm._s(month.name + ' ' + year.name)
        }
      }), _vm._v(" "), _vm._l((month.news), function(news, n) {
        return _c('div', {
          key: ("" + (news.name) + (news.newsdate)),
          staticClass: "news"
        }, [_c('div', {
          staticClass: "top"
        }, [(news.image !== null) ? _c('sky-crop', {
          attrs: {
            "src": news.image.skyCropUrl,
            "alt": news.image.alttext,
            "mode": "cover"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "info"
        }, [_c('h3', {
          domProps: {
            "textContent": _vm._s(news.name)
          }
        }), _vm._v(" "), _c('time', {
          domProps: {
            "textContent": _vm._s(_vm.convertDate(news.newsdate))
          }
        })])], 1), _vm._v(" "), (news.teaser) ? _c('p', {
          domProps: {
            "textContent": _vm._s(news.teaser)
          }
        }) : _vm._e(), _vm._v(" "), _c('ge-link', {
          attrs: {
            "theme": "green",
            "href": news.url
          }
        })], 1)
      })], 2)
    }))
  }), _vm._v(" "), (_vm.list.results.pagination.total > _vm.list.results.items.length) ? _c('div', {
    staticClass: "search-more"
  }, [(_vm.list.preferences.pagination && _vm.list.results.pagination.offset != 0) ? _c('button', {
    staticClass: "search-previous ge-link green plain",
    on: {
      "click": _vm.previous
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.messagePrevious)
    }
  }), _vm._v(" "), _c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.list.results.items.length >= _vm.list.results.pagination.limit) ? _c('button', {
    staticClass: "search-next ge-link green plain",
    on: {
      "click": _vm.next
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.messageNext)
    }
  }), _vm._v(" "), _c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1) : _vm._e()]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-6a42ad88"}!./scripts/sky-news/sky-news.html
// module id = 357
// module chunks = 1